<template>
  <div
    class="regras-overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="regras-passaporte-titulo"
  >
    <div class="regras-painel">
      <header class="regras-cabecalho">
        <h2 id="regras-passaporte-titulo" class="regras-titulo">
          Foto para passaporte
          <span class="regras-titulo-destaque">no padrão oficial</span>
        </h2>
        <p class="regras-subtitulo">
          Confira as regras do Itamaraty antes da foto.
        </p>
      </header>

      <div class="regras-exemplos">
        <img
          class="regras-exemplos-img"
          :src="imagemRegras"
          alt="Assim pode: foto enquadrada, fundo branco, expressão neutra e sem acessórios. Assim não: sorrindo, fundo colorido, de óculos ou de chapéu ou boné."
          draggable="false"
          @contextmenu.prevent
          @dragstart.prevent
        />
      </div>

      <div class="regras-govbr">
        <img
          class="regras-qrcode"
          :src="imagemQrCode"
          alt="QR Code com as regras da foto para passaporte no gov.br"
          draggable="false"
          @contextmenu.prevent
          @dragstart.prevent
        />
        <div class="regras-govbr-texto">
          <div class="regras-govbr-titulo">Veja todas as regras no gov.br</div>
          <p class="regras-govbr-lista">
            5 x 7 cm, colorida e recente · fundo branco · rosto e ombros
            visíveis · sem sorrir · sem óculos escuros, chapéu ou boné · evite
            roupa branca
          </p>
          <p class="regras-govbr-fonte">
            Aponte a câmera do celular para o QR Code · Fonte: Itamaraty
            (gov.br/mre)
          </p>
        </div>
      </div>

      <div class="regras-acoes">
        <button
          type="button"
          class="regras-btn regras-btn-voltar"
          data-test="regras-passaporte-voltar"
          @click="$emit('voltar')"
        >
          Voltar
        </button>
        <button
          type="button"
          class="regras-btn regras-btn-continuar"
          data-test="regras-passaporte-continuar"
          @click="$emit('continuar')"
        >
          Entendi, continuar
          <svg
            class="regras-btn-seta"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M5 12h14M13 6l6 6-6 6"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import imagemRegras from "@/assets/passaporte-regras.png";
import imagemQrCode from "@/assets/passaporte-qrcode-govbr.png";

// Regras da foto de passaporte, mostradas antes de seguir com o tipo
// passaporte. Só avisa: quem decide o que fazer é a tela que abre o modal.
export default {
  name: "ModalRegrasPassaporte",
  data() {
    return { imagemRegras, imagemQrCode };
  },
};
</script>

<style scoped>
/* --u acompanha a tela do totem (1080x1920 → ~10,8px) e encolhe junto
   em telas mais baixas, para o modal caber sem scroll. */
.regras-overlay {
  --u: min(1vw, 0.5625vh);
  --rosa: #fe3c71;
  --rosa-titulo: #f22283;
  --rosa-claro: #ffe3ef;
  --fundo: #fff5f9;
  --texto: #231f1e;
  --texto-suave: #4a4446;
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(35, 31, 30, 0.6);
}

.regras-painel {
  width: calc(var(--u) * 92);
  max-height: 96vh;
  overflow-y: auto;
  box-sizing: border-box;
  padding: calc(var(--u) * 5) calc(var(--u) * 4);
  border-radius: calc(var(--u) * 3);
  background: var(--fundo);
  color: var(--texto);
  box-shadow: 0 calc(var(--u) * 1.5) calc(var(--u) * 5) rgba(0, 0, 0, 0.35);
}

.regras-cabecalho {
  text-align: center;
}

.regras-titulo {
  margin: 0;
  font-size: calc(var(--u) * 6.4);
  font-weight: 700;
  line-height: 1.15;
}

.regras-titulo-destaque {
  display: block;
  color: var(--rosa-titulo);
}

.regras-subtitulo {
  margin: calc(var(--u) * 1.6) 0 0;
  font-size: calc(var(--u) * 3.3);
  color: var(--texto-suave);
}

.regras-exemplos {
  margin-top: calc(var(--u) * 4);
  padding: calc(var(--u) * 3);
  border-radius: calc(var(--u) * 2.4);
  background: #ffffff;
}

.regras-exemplos-img {
  display: block;
  width: 100%;
  height: auto;
}

.regras-govbr {
  display: flex;
  align-items: center;
  gap: calc(var(--u) * 3.5);
  margin-top: calc(var(--u) * 3.5);
  padding: calc(var(--u) * 3.5);
  border-radius: calc(var(--u) * 2.4);
  background: var(--rosa-claro);
}

.regras-qrcode {
  flex: 0 0 auto;
  width: calc(var(--u) * 19);
  height: calc(var(--u) * 19);
  padding: calc(var(--u) * 1);
  border-radius: calc(var(--u) * 1.6);
  background: #ffffff;
}

.regras-govbr-titulo {
  font-size: calc(var(--u) * 4.2);
  font-weight: 600;
  line-height: 1.2;
}

.regras-govbr-lista {
  margin: calc(var(--u) * 1.4) 0 0;
  font-size: calc(var(--u) * 3);
  line-height: 1.35;
  color: var(--texto-suave);
}

.regras-govbr-fonte {
  margin: calc(var(--u) * 1.4) 0 0;
  font-size: calc(var(--u) * 2.3);
  line-height: 1.35;
  color: #8a7f84;
}

.regras-acoes {
  display: flex;
  gap: calc(var(--u) * 3);
  margin-top: calc(var(--u) * 5);
}

.regras-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: calc(var(--u) * 1.6);
  min-height: calc(var(--u) * 11);
  padding: 0 calc(var(--u) * 4);
  border-radius: calc(var(--u) * 2);
  font-size: calc(var(--u) * 3.8);
  font-weight: 600;
  cursor: pointer;
}

.regras-btn-voltar {
  flex: 1 1 0;
  border: calc(var(--u) * 0.35) solid var(--rosa);
  background: #ffffff;
  color: var(--rosa);
}

.regras-btn-continuar {
  flex: 2 1 0;
  border: none;
  background: var(--rosa);
  color: #ffffff;
  box-shadow: 0 calc(var(--u) * 0.8) calc(var(--u) * 2.4)
    rgba(254, 60, 113, 0.35);
}

.regras-btn:active {
  transform: scale(0.98);
}

.regras-btn-seta {
  width: calc(var(--u) * 4.2);
  height: calc(var(--u) * 4.2);
}
</style>
